import BannerComp from "../components/BannerComp";
import Seo from "../components/Seo";
import { createBreadcrumbSchema, createWebPageSchema } from "../lib/seo";
import styles from "./TermsConditions.module.css";

const seo = {
  title: "Terms & Conditions | MIT4Doctors",
  description:
    "Please review the terms that apply to using this website and our services.",
  schema: [
    createWebPageSchema({
      path: "/terms-and-conditions",
      title: "Terms & Conditions",
      description:
        "Please review the terms that apply to using this website and our services.",
    }),
    createBreadcrumbSchema("/terms-and-conditions", "Terms & Conditions"),
  ],
};

export default function TermsConditions() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/terms-and-conditions"
        schema={seo.schema}
      />
      <BannerComp
        heading="Terms & Conditions"
        paragraph="Please review the terms that apply to using this website and our services."
        centered
        BannerBgImg="/img/banners/about_hero.webp"
      />

      <section className={styles.section}>
        <div className={styles.content}>
          <h2>
            Medical Imaging Technology Services Inc. <span>(MITS)</span>
          </h2>
          <strong className={styles.strongDiv}>
            Effective: <span className={styles.spanDiv}>1 Sep, 2022</span>
          </strong>
          <h3>Parties</h3>
          <span className={styles.text}>
            This Terms and Conditions document (“Agreement”) is entered into by
            and between Medical Imaging Technology Services Inc. (“MITS”), a
            Tennessee Corporation, and the healthcare practice (“DR”) that has
            signed a two-year service agreement with MITS.
          </span>
          <h3>Scope of Services</h3>
          <p className={styles.redText}>
            MITS shall provide DR with the following:
          </p>
          <ul>
            <li>
              Neurofeedback /biofeedback devices, software, processes, training,
              and know-how to use equipment products and services.
            </li>
            <li>
              Equipment and services to perform Brain Mapping and Brain Training
              as defined in the Service Agreement.
            </li>
          </ul>
          <p className={styles.redText}>
            DR agrees to be solely responsible for:
          </p>
          <ul>
            <li>
              Scheduling, billing, coding, and collecting payments for any
              services or products provided to patients.
            </li>
            <li>
              Compliance with all applicable laws, regulations, and healthcare
              standards.
            </li>
          </ul>
          <h3>Term of Agreement</h3>
          <ul>
            <li>The Agreement is for an initial two-year term.</li>
            <li>
              It automatically renews for consecutive two-year periods unless
              either party provides written notice of non-renewal three months
              before the end of the current term.
            </li>
          </ul>
          <h3>Payment Terms & Kit Fees</h3>
          <ul>
            <li>
              DR shall pay MITS for each kit used in accordance with Exhibit B
              of the Service Agreement.
            </li>
            <li>
              The kit fee will never exceed 60% of the cap of $499, ensuring
              fairness and market value.
            </li>{" "}
            <li>
              MITS charges up to $299 per kit, depending on the products and
              services provided.
            </li>{" "}
            <li>Typical kit fees range between $179 and $249.</li>
          </ul>
          <h3>
            $99 RGC Minimum Payment - Minimum RGC Payment
          </h3>
          <p>
            The Parties acknowledge and agree that the $99 fee per Brain Mapping
            and Brain Training kit, defined as a Revenue Generating Cost (RGC)
            in Exhibit B, covers the direct costs of goods, services, equipment,
            software, and support provided by MITS. This $99 fee is always due
            and payable by DR to MITS, regardless of whether DR is reimbursed by
            patients, insurers, or other third parties. The payment of this $99
            RGC fee is not contingent upon collections or reimbursements
            received by DR, but instead reflects the direct costs incurred by
            MITS in providing the Products and Services.
          </p>
          <h3>Kit Cost Calculation</h3>
          <ul>
            <li>
              MITS will add up all the kits from the monthly report provided by
              DR’s biller.
            </li>
            <li>The final kit cost will never exceed 60% of the $499 cap.</li>{" "}
            <li>
              We will charge up to $299 per kit, but no more than 60% of the
              $499 cap in place.
            </li>
          </ul>
          <h3>Reporting & Record-Keeping</h3>
          <ul>
            <li>
              DR shall provide MITS with a monthly report from the biller,
              including kit charges up to the $499 cap, cash-pay services,
              sales, insurance collections, and other required information. They
              will give us a report of all kits collected up to $499.
            </li>
            <li>
              DR shall maintain accurate records and grant billers access to
              verify reports and payments to MITS up to $499.00.
            </li>
          </ul>
          <h3>Billing & Balance Billing</h3>
          <ul>
            <li>
              DR is solely responsible for billing decisions, including any
              patient balance billing, in compliance with applicable
              regulations.
            </li>
            <li>
              MITS does not participate in or advise on insurance billing or
              medical necessity.
            </li>
          </ul>
          <h3>Confidentiality & Non-Disclosure</h3>
          <ul>
            <li>
              DR shall not disclose or use MITS’s confidential information for
              any purpose other than fulfilling obligations under this
              Agreement.
            </li>
            <li>
              Confidentiality provisions survive for five years after
              termination.
            </li>
          </ul>
          <h3>Indemnification</h3>
          <ul>
            <li>
              DR shall indemnify and hold harmless MITS and its affiliates from
              any claims, losses, liabilities, and expenses arising from DR’s
              activities, including billing, coding, and patient care.
            </li>
          </ul>
          <h3>Dispute Resolution</h3>
          <ul>
            <li>
              Disputes will be mediated in Tennessee within 30 days of written
              notice.
            </li>

            <li>
              If not resolved, disputes shall be resolved through final and
              binding arbitration per the AAA Commercial Arbitration Rules in
              Gibson County, Tennessee.
            </li>
          </ul>
          <h3>Governing Law</h3>
          <ul>
            <li>
              This Agreement is governed by and construed in accordance with
              Tennessee law.
            </li>

            <li>Venue for disputes shall be in Jackson, Tennessee.</li>
          </ul>
          <h3>Questions or Requests?</h3>
          <p>Please contact MITS at:</p>
          <p className={styles.redText}>
            <b>Brian Ballinger, CEO</b>
          </p>{" "}
          <p className={styles.redText}>
            <b>319 Vann Drive, Suite E 60, Jackson, Tennessee</b>
          </p>{" "}
          <p className={styles.redText}>
            <b>
              Email:{" "}
              <a href="mailto:Brianballinger10280@gmail.com">
                Brianballinger10280@gmail.com
              </a>
            </b>
          </p>
          <h3>Acceptance</h3>
          <p>
            By continuing to use MITS’s Products and Services, DR acknowledges
            and agrees to these Terms and Conditions as part of their signed
            Service Agreement.
          </p>
        </div>
      </section>
    </>
  );
}
